import { createFileRoute } from '@tanstack/react-router';

import { AnalyticsMoveReportPage } from '@pages/analytics';
import { ANALYTICS_MOVE_TAB_REGISTRATION_TOP30 } from '@pages/analytics/ui/analytics-move-tabs';
import { Skeleton, Stack } from '@shared/ui';

export const Route = createFileRoute('/$locale/_authenticated/analytics-move/registration-top30')({
  component: AnalyticsMoveRegistrationTop30Route,
  pendingComponent: AnalyticsMoveRegistrationTop30Pending,
  pendingMs: 0,
  pendingMinMs: 0,
});

function AnalyticsMoveRegistrationTop30Route() {
  return <AnalyticsMoveReportPage activeTab={ANALYTICS_MOVE_TAB_REGISTRATION_TOP30} />;
}

function AnalyticsMoveRegistrationTop30Pending() {
  return (
    <Stack gap="md" data-testid="analytics-registration-top30-pending">
      <Skeleton className="h-10 w-72" />
      <Skeleton className="h-10 w-full" />
      <div className="space-y-3">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={`registration-top30-pending-${String(index)}`} className="h-40 w-full" />
        ))}
      </div>
    </Stack>
  );
}
